export default {

    // general slider settings
    slideReordering: false,

    // loop
    loop: true,

    // autoplay
    autoplay: false,
    autoplaySpeed: 3000,

    dots: true,
    dotsPosition: 'bottom',
    dotAccentColor: '#1c8ff3',

    arrows: true,
    arrowBg: '#1c8ff3',
    arrowColor: '#fff',
    arrowBgHover: '#fff',
    arrowColorHover: '#1c8ff3',
    arrowSize: 30,
    arrowRadius: 4,

    partialSlider: false,
    useSpacing: false,
    spaceBetween: 15,

    alwaysFullWidthImg: false,


    // slide individual settings
    slides: [
        {
            slideId: 'content-slide-'+Math.random().toString(36).substr(2, 16),
            imageUrl: 'https://www.appjustable.com/weebly/app_in_process/dummy-content/image-slider-placeholder2.jpg',
            altTag: 'Alt description for image',
            useLink: false,
            link: 'https://www.waddons.com',
            target: '_blank'
        },
        {
            slideId: 'content-slide-'+Math.random().toString(36).substr(2, 16),
            imageUrl: 'https://www.appjustable.com/weebly/app_in_process/dummy-content/image-slider-placeholder2.jpg',
            altTag: 'Alt description for image',
            useLink: false,
            link: 'https://www.waddons.com',
            target: '_blank'
        },
        {
            slideId: 'content-slide-'+Math.random().toString(36).substr(2, 16),
            imageUrl: 'https://www.appjustable.com/weebly/app_in_process/dummy-content/image-slider-placeholder2.jpg',
            altTag: 'Alt description for image',
            useLink: false,
            link: 'https://www.waddons.com',
            target: '_blank'
        },
    ]

}


// WEBPACK FOOTER //
// ./src/store/elementSettings/imageslidersettings.js